'use strict';

(() => {
  const template = document.createElement('template');

  template.innerHTML = /* html */ `
    <style>
      .d-flex { display: flex }
      .d-flex-media-screen { display: flex; max-height: 80vh; gap: 20px; }
      .rounded { border-radius: 0.375rem; }
      .border { border: 1px solid #dee2e6 }
      .p-3 { padding: 1rem; }
      .mb-3 { margin-bottom: 1rem; }
      .mt-3 { margin-top: 1rem; }
      .me-3 { margin-left: 1rem; }
      .bg-light { background-color: #f8f9fa }
      .container-left { width: 70%; max-height: 100% }
      .container-right { width: 30%; display: block; word-wrap: break-word; }
      img { max-width: 100%; max-height: 100%; display: block; }
      video { width: 100%; max-height: 100%; display: block; }
      audio { max-width: 100%; display: block; }
      .btn { text-align: center; vertical-align: middle; padding: 0.4rem 0.7rem; border-radius: 4px; text-decoration: none; display: inline-block; border: 1px solid #adadad; cursor: pointer; font-size: 1.1rem; }
      .btn-danger { color:#ffffff; background-color: #dc3545; }
      @media only screen and (max-width: 576px) {
        .d-flex-media-screen { display: block; overflow: hidden; overflow-y: auto; }
        .container-left { margin-bottom: 10px; max-width: 100%; width: unset; }
        .container-right { font-size: 16px; max-width: 100%; width: unset; }
      }
      audio::-webkit-media-controls-panel { background-color: #128cc9; }
      textarea { width: 100%; height: 80px; font-family: inherit; font-size: inherit;}
    </style>

    <div class="d-flex-media-screen">
      <div class="bg-light border rounded p-3 container-left">
      </div>
      <div class="border p-3 rounded container-right">
        <default-label>URL</default-label><br>
        <textarea class="mb-1 rounded border path"></textarea>
        <div class="mb-3"><button class="btn btn-sm btn-second btn-copy-url">copy</button></div>
        <div class="info-box mb-3"></div>
        <default-label>Delete</default-label>
        <confirm-delete text-cancel="abbrechen">
          <button slot="right" class="btn btn-danger me-3" type="submit">löschen</button>
        </confirm-delete>
      </div>
    </div>
    `;

  class MediaOverview extends HTMLElement {
    #root = null;
    #src = '';
    #mediaType = 'images';

    constructor() {
      super();
      this.#root = this.attachShadow({ mode: 'open' });
      this.#root.appendChild(template.content.cloneNode(true));
      this.containerLeft = this.#root.querySelector('div.container-left');
      this.containerRight = this.#root.querySelector('div.container-right');
      this.path = this.#root.querySelector('.path');
      this.infoBox = this.#root.querySelector('div.info-box');
      this.btnSubmit = this.#root.querySelector('button[type="submit"]');
      this.btnCopyUrl = this.#root.querySelector('button.btn-copy-url');
    }

    static get observedAttributes() {
      return ['src', 'media-type'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'media-type') {
        this.#insertMedia(newValue);
        this.#mediaType = newValue;
      }
      if (name === 'src') {
        this.#src = newValue.replace(BASE_URL, './../').replace('./../../', './../');
        this.path.value =
          BASE_URL +
          newValue
            .replace(BASE_URL + '_media/', '')
            .replace('./../../', '')
            .replaceAll('\\', '/');
      }
    }

    connectedCallback() {
      this.btnSubmit.addEventListener('click', (e) => {
        this.#deleteMedia(this.#src, this.#mediaType);
      });

      this.btnCopyUrl.addEventListener('click', (e) => {
        this.path.select();
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(this.path.value);
        } else {
          document.execCommand('copy');
        }
      });
    }

    /**
     * FUNCTIONS
     */
    #insertMedia(newValue) {
      if (newValue === 'images' || newValue === 'avatars' || newValue === 'seo') {
        this.#insertImage(this.getAttribute('src'), this.getAttribute('file-size'));
      } else if (newValue === 'videos') {
        this.#insertVideo(this.getAttribute('src'), this.getAttribute('file-size'));
      } else if (newValue === 'audios') {
        this.#insertAudio(this.getAttribute('src'), this.getAttribute('file-size'));
      } else if (newValue === 'pdf') {
        this.#insertPDF(this.getAttribute('src'), this.getAttribute('file-size'));
      } else if (newValue === 'doc') {
        this.#insertDoc(this.getAttribute('file-size'));
      } else if (newValue === 'excel') {
        this.#insertExcel(this.getAttribute('file-size'));
      } else if (newValue === 'zip') {
        this.#insertZip(this.getAttribute('file-size'));
      }
    }

    #insertImage(src, fileSize) {
      this.containerLeft.innerHTML = /* html */ `<img class="media" src="${src}" title="${src}">`;
      const image = this.containerLeft.querySelector('img');

      image.addEventListener('load', () => {
        this.infoBox.innerHTML =
          /* html */ `<default-label>Image size</default-label>
            <div class="mb-3">${image.naturalWidth} x ${image.naturalHeight} Pixel</div>` + this.#createFileSize(fileSize);
      });
    }

    #insertVideo(src, fileSize) {
      this.containerLeft.innerHTML = /* html */ `<video controls>
        <source src="${src}" type="video/mp4">
        <source src="${src}" type="video/ogg">
        Your browser does not support the video tag.
      </video>`;

      this.infoBox.innerHTML = this.#createFileSize(fileSize);
    }

    #insertAudio(src, fileSize) {
      this.containerLeft.innerHTML = /* html */ `<audio src="${src}" controls></audio>`;
      this.infoBox.innerHTML = this.#createFileSize(fileSize);
    }

    #insertPDF(src, fileSize) {
      this.containerLeft.innerHTML = /* html */ `<div class="d-block">
        <div class="d-flex justify-content-center">
          <img src="./../../_media/___page_internal/PDF_file_icon.webp" alt="pdf icon" style="width: 80px; height: auto;">
        </div>
        <div class="mt-3">
          <a href="${src}" target="_blank" rel="noopener noreferrer">
            <div class="btn">${BUTTON_TEXT_OPEN}</div>
          </a>
        </div>
      </div>`;
      this.infoBox.innerHTML = this.#createFileSize(fileSize);
    }

    #insertDoc(fileSize) {
      this.containerLeft.innerHTML = /* html */ `<div class="d-block">
        <div class="d-flex justify-content-center">
          <img src="./../../_media/___page_internal/Word_file_icon.webp" alt="doc icon" style="width: 80px; height: auto;">
        </div>
      </div>`;
      this.infoBox.innerHTML = this.#createFileSize(fileSize);
    }

    #insertExcel(fileSize) {
      this.containerLeft.innerHTML = /* html */ `<div class="d-block">
        <div class="d-flex justify-content-center">
          <img src="./../../_media/___page_internal/Excel_file_icon.webp" alt="excel icon" style="width: 80px; height: auto;">
        </div>
      </div>`;
      this.infoBox.innerHTML = this.#createFileSize(fileSize);
    }

    #insertZip(fileSize) {
      this.containerLeft.innerHTML = /* html */ `<div class="d-block">
        <div class="d-flex justify-content-center">
          <img src="./../../_media/___page_internal/Zip_file_icon.webp" alt="zip icon" style="width: 80px; height: auto;">
        </div>
      </div>`;
      this.infoBox.innerHTML = this.#createFileSize(fileSize);
    }

    #createFileSize(fileSize) {
      return /* html */ `<default-label>File Size</default-label>
      <div>${fileSize}</div>
      `;
    }

    /**
     * FETCH
     */
    #deleteMedia = async (src, type) => {
      const params = {
        action: 'delete-media',
        src: src,
        type: type,
      };

      await fetch('./../../inc/api.php', {
        method: 'POST',
        body: JSON.stringify(params),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.original === 1 && res.thumbnail === 1) {
            window.location.reload();
          } else if (res.original === 2) {
            alert(DELETE_FILE_ERROR);
          } else {
            alert(FILE_NOT_EXIST);
          }
        })
        .catch((error) => console.log(`media-overview#deleteMedia: \n` + error));
    };
  }

  customElements.define('media-overview', MediaOverview);
})();
